import * as React from 'react';
import classNames from 'clsx';
import { text } from 'src/common/text';
import { isAndroid, isIOS, isMobileOnly } from 'react-device-detect';

import '../styles/Link.css';

import { AppBadge, APP_BADGE_GOOGLE_PLAY_PROPS, APP_BADGE_PROPS_IOS } from '../components/AppBadge';
import { Separator } from './Separator';
import { useMobileSetting } from '../hooks/useMobileSetting';

export const LandingMobile: React.FC = ({ children }) => {
  const { showLanding, handlePreferWeb } = useMobileSetting();

  if (!showLanding) {
    return <>{children}</>;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <p
        style={{
          color: '#67747E',
          fontSize: '18px',
          lineHeight: '25px',
          textAlign: 'center',
          maxWidth: 250,
          marginBottom: 40,
        }}
      >
        {text('LBL_LEAD_SMARTPHONE')}
      </p>
      {isAndroid && <AppBadge {...APP_BADGE_GOOGLE_PLAY_PROPS} height={60} />}
      {isIOS && <AppBadge {...APP_BADGE_PROPS_IOS} height={60} />}
      <Separator style={{ width: '100%', paddingTop: 44, paddingBottom: 64, paddingLeft: 24, paddingRight: 24 }} />
      <button className={classNames('link', 'link--bold', { 'link--mobile': isMobileOnly })} onClick={handlePreferWeb}>
        {text('LBL_USE_BROWSER')}
      </button>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/LandingMobile.tsx